import { Component, EventEmitter, Input, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Observable } from 'rxjs';

import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { FilesActions } from 'src/app/common/store/actions/files.actions';

import { CarEditDialogComponent } from '../car-edit/car-edit.component';

import { DateRange, MatCalendar, MatCalendarCellClassFunction, MatCalendarCellCssClasses } from '@angular/material/datepicker';

import { BuyActions } from 'src/app/common/store/actions/buy.actions';

import { ProviderOfferDialogComponent } from '../provider-offer-dialog/provider-offer-dialog.component';
import { CdkOverlayOrigin } from '@angular/cdk/overlay';

import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { ProposalStatus } from 'src/app/public/buy/constants/buy-basic-data';
import { ProposalDialogComponent } from 'src/app/public/buy/elements/proposal-dialog/proposal-dialog.component';
import { NumberDialogComponent } from 'src/app/public/common/components/number-dialog/number-dialog.component';
import { SelectDialogComponent } from 'src/app/public/common/components/select-dialog/select-dialog.component';
import { TableDialogComponent } from 'src/app/public/common/components/table-dialog/table-dialog.component';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { AppointmentStatus } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource, Currency } from 'src/app/public/common/constants/general-basic-data';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { ObjectData } from 'src/app/public/common/models/object-data.model';
import { Price } from 'src/app/public/common/models/string-data.model';
import { JobDialogComponent } from 'src/app/public/keep/elements/job-dialog/job-dialog.component';
import { BookingStatus } from 'src/app/public/rent/constants/rent-basic-data';
import { BookingDialogComponent } from 'src/app/public/rent/elements/booking-dialog/booking-dialog.component';
import { CarStatus, CarBusinessLine, CarBasicData } from '../../constants/car-basic-data';
import { Car } from '../../models/car.model';
import { MatExpansionModule } from '@angular/material/expansion';
import { ProviderOffersComponent } from '../provider-offers/provider-offers.component';
import { JobsComponent } from 'src/app/public/keep/elements/jobs/jobs.component';
import { PostingsComponent } from 'src/app/public/keep/elements/postings/postings.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'app-car-card-seller',
    templateUrl: './car-card-seller.component.html',
    styleUrls: ['./car-card-seller.component.css'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, MatProgressSpinnerModule, MatIconModule, MatDividerModule, MatSlideToggleModule, MatExpansionModule, ProviderOffersComponent, PostingsComponent, JobsComponent]
})
export class CarCardSellerComponent implements OnInit {
  
  @Input() car: Car = new Car();
  @Input() carImagesFolder: FileData[] = [];
  @Input() currentDealer: Dealer = new Dealer();

  currentImageIndex: number = 0;

  currentImageIndexSubject:BehaviorSubject<number>;
  currentProviderActiveStatus$:BehaviorSubject<boolean>;

  currentImage: any;
  
  fetchingImage: boolean = this.car.providerActive;

  providerActive = true;

  buyActive: boolean = this.getActiveState(CarBusinessLine.BUY);
  rentActive: boolean = this.getActiveState(CarBusinessLine.RENT);

  showBookingAddNew: boolean = false;
  showBookingCalendar: boolean = false;

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;

  selectedDateRange: DateRange<Date>;

  ProposalStatus = ProposalStatus;
  AppointmentStatus = AppointmentStatus;

  newJobCarId = "";
  newJobCount = 0;

  newAppointmentCarId = "";
  newAppointmentCount = 0;

  objectSource: ObjectSource = ObjectSource.PARK
  CarBusinessLine = CarBusinessLine

  isPosting: boolean = true

  constructor(
    private router: Router,
    private store: Store, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog) {

      this.currentImageIndexSubject = new BehaviorSubject<number>(0);

      this.currentProviderActiveStatus$ = new BehaviorSubject<boolean>(this.car.providerActive);

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.tomorrowDate.getDate()+1);
      this.yesterdayDate.setDate(this.yesterdayDate.getDate()-1);

      this.selectedDateRange = new DateRange<Date>(this.todayDate, this.tomorrowDate);
    }

  ngOnInit(): void {

    this.currentImageIndexSubject.subscribe(
      (i: number) =>  {
        this.currentImage = this.getImage(i);
      }
    );
    this.currentImage = this.getImage(0);

    this.currentProviderActiveStatus$.subscribe(
      (status: boolean) =>  {
        this.providerActive = status;
      }
    );

    this.isPosting = (this.car.status === CarStatus.POSTING_TO_PROCESS)
    
  }

  ngOnChanges(changes: SimpleChanges): void {
    
    const latestImagesFolder = changes['carImagesFolder'];
    if (latestImagesFolder != undefined) {
      if ((latestImagesFolder.currentValue?.length as number) === 1) {
        
        this.currentImageIndexSubject.next(0);
      }
    }

    const latestProviderActive = changes['car'];
    if (latestProviderActive != undefined) {

        this.currentProviderActiveStatus$.next(latestProviderActive.currentValue.providerActive as boolean)
      
    }

    this.buyActive = this.getActiveState(CarBusinessLine.BUY);
    this.rentActive = this.getActiveState(CarBusinessLine.RENT);

    ////this.buyPrice = this.getPrice(CarBusinessLine.BUY);
    ////this.rentPrice = this.getPrice(CarBusinessLine.RENT);
    //console.log("hellooo 1 "+this.sellActive);
    //console.log("hellooo 2 "+this.car.sellActive);
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  createImageFromBlob(imageData: Blob): any {
    let objectUrl = URL.createObjectURL(imageData);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);    
  }

  getImage(i: number): any{

    if(this.carImagesFolder != undefined && this.carImagesFolder.length > 0 ){
      let objectUrl = URL.createObjectURL(this.carImagesFolder[i].blob);     
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 
    }
  }

  openBuyPriceHistoryDialog(carId: string, businessLine: CarBusinessLine): void {

    const dialogRef = this.dialog.open(TableDialogComponent, {
      data: {priceHistory: this.car.buyPriceHistory, businessLine: businessLine, label: "Price"}
    });

    dialogRef.afterClosed().subscribe(() => {
  
    });
  }

  openRentPriceHistoryDialog(carId: string, businessLine: CarBusinessLine): void {

    const dialogRef = this.dialog.open(TableDialogComponent, {
      data: {priceHistory: this.car.rentDayRateHistory, businessLine: businessLine, label: "Price"}
    });

    dialogRef.afterClosed().subscribe(() => {
  
    });
  }

  openOfferDialog(carId: string): void {
    let amount = 0;
    
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: amount, label: "Offer"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      console.log('New offer = '+result+ " car Id = "+carId);

      if(result > 0 )
        this.store.dispatch(DealerActions.createNewCarOfferSubmit( {carId: carId, amount: result }));
    });
  }


  openNewJobDialog(carId: string){
      
    const dialogRef = this.dialog.open(JobDialogComponent, {

      data: new ObjectData(this.objectSource, "", 0, CarBusinessLine.KEEP, carId)

    });
  }

  openNewAppointmentDialog(carId: string): void{

    this.newAppointmentCarId = carId;
    this.newAppointmentCount++;

  }

  /** 
  openProposalDialog(carId: string, prop?: Proposal): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let proposal: Proposal;

    if(prop !== undefined){
      proposal = JSON.parse(JSON.stringify(prop!));
      console.log('hello 1')
    }else{
      proposal = new Proposal();
      proposal.carId = carId;
      console.log('hello 2')
    }

    let isReschedule: boolean = (proposal.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: proposal
    });
    
    dialogRef.afterClosed().subscribe((result: Proposal) => {

      //console.log('helloo = '+JSON.stringify(result));
      if(result != undefined ){

        //console.log('New proposal = '+result.status+ " date = "+result.appointmentDate+ " car Id = "+JSON.stringify(result));
        if(result.id === ''){
          console.log('new')
          this.store.dispatch(BuyActions.proposalNewSubmit ( { proposal: result }));
          return;
        }

        if(isReschedule){
          console.log('reschedule')
          this.store.dispatch(BuyActions.proposalRescheduleSubmit ( { proposalId: result.id, rescDate: result.rescheduleDate }));
          return;
        }

        else{
          console.log('update')
          this.store.dispatch(BuyActions.proposalUpdateSubmit ( { proposal: result }));          
          return;
        } 
      }  
    });
  }

  */
 
  openBookingDialog(bookingId: number): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.carId, bookingId );

    const dialogRef = this.dialog.open(BookingDialogComponent, {
      data: objectData
    });
  }

  openProposalDialog(proposalId: number, isModification: boolean): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, this.car.carId, proposalId );

    const dialogRef = this.dialog.open(ProposalDialogComponent, {
      data: objectData
    });

    if(isModification){
      let instance = dialogRef.componentInstance
      instance.isModification = isModification
    }
  }
  
  updateProposalStatus(proposalId: number, status: ProposalStatus){

    //console.log('heyy   '+status.toString());

    this.store.dispatch(BuyActions.proposalStatusUpdateSubmit ( { proposalId: proposalId, status: status, objectSource: this.objectSource }));

  }


  /*
  openAppointmentDialog(carId: string, prop?: Appointment): void {

    //console.log('index = '+JSON.parse(JSON.stringify(prop!)));
    let appointment: Appointment;

    if(prop !== undefined){
      appointment = JSON.parse(JSON.stringify(prop!));
      console.log('hello 1')
    }else{
      appointment = new Appointment();
      appointment.carId = carId;
      console.log('hello 2')
    }

    let isReschedule: boolean = (appointment.rescheduleDate === '1'); // 1 is to indicate that reschedule has to be edited

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(AppointmentDialogComponent, {
      data: appointment
    });
    
    dialogRef.afterClosed().subscribe((result: Appointment) => {

      //console.log('helloo = '+JSON.stringify(result));
      
      if(result != undefined ){

        //console.log('New appointment = '+result.status+ " date = "+result.appointmentDate+ " car Id = "+JSON.stringify(result));
        if(result.id === 0){
          console.log('new')
          this.store.dispatch(CommonActions.appointmentNewSubmit ( { appointment: result, objectSource: this.objectSource }));
          return;
        }

        if(isReschedule){
          console.log('reschedule')
          this.store.dispatch(CommonActions.appointmentRescheduleSubmit ( { appointmentId: result.id, rescDate: result.rescheduleDate, objectSource: this.objectSource }));
          return;
        }

        else{
          console.log('update')
          this.store.dispatch(CommonActions.appointmentUpdateSubmit ( { appointment: result, objectSource: this.objectSource }));          
          return;
        } 
      }  
    });
  }

  updateAppointmentStatus(appointmentId: number, status: AppointmentStatus){

    //console.log('heyy   '+status.toString());

    this.store.dispatch(CommonActions.appointmentStatusUpdateSubmit ( { appointmentId: appointmentId, status: status, objectSource: this.objectSource }));

  }

  rescheduleAppointment(appointment: Appointment){

    let prop: Appointment = JSON.parse(JSON.stringify(appointment));
    
    prop.rescheduleDate = '1'; // 1 is to indicate that reschedule has to be edited
    console.log('heyy   '+JSON.parse(JSON.stringify(prop)));

    this.openAppointmentDialog("", prop);
  }

   */
/*
  onSelectedDateRangeChange(date: Date): void {
    if (
      this.selectedDateRange &&
      this.selectedDateRange.start &&
      date > this.selectedDateRange.start &&
      !this.selectedDateRange.end
    ) {
      this.selectedDateRange = new DateRange(
        this.selectedDateRange.start,
        date
      );
    } else {
      this.selectedDateRange = new DateRange(date, null);
    }
  }

  filterPastDates = (date: Date): boolean => {
    if ( date > this.yesterdayDate) {

      return true;
    } else {
      return false;
    }
  }

  filterBookedDates = (date: Date): boolean => {

    let available: boolean = true;

    this.car.bookings.forEach(
      (booking: Booking) => {
        if (booking.endDate >= ""+date.valueOf() && ""+date.valueOf()  >= booking.startDate) {
          available = false;
          return;
        }
      }
    );
    return available;;
  }

  filterPastDatesAndBookedDates = (date: Date): boolean => {

    let available: boolean = true;

    if ( ! (date > this.yesterdayDate) ) {
      return false;
    } 

    this.car.bookings.forEach(
      (booking: Booking) => {
        if (booking.endDate >= ""+date.valueOf() && ""+date.valueOf()  >= booking.startDate) {
          available = false;
          return;
        }
      }
    );
    return available;
  }

  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    
    if (view === 'month') {

      return this.car.bookings.find( 
        (booking) => (booking.endDate >= ""+cellDate.valueOf() && ""+cellDate.valueOf()  >= booking.startDate) 
        ) ? 'booked-date' : '';
    }

    return '';
  };


  addNewBooking(carId: string): void{

    let booking: Booking = new Booking();

    booking.carId = carId;

    booking.startDate = this.selectedDateRange.start?.toISOString()!;
    booking.endDate = this.selectedDateRange.end?.toISOString()!;

    this.store.dispatch(RentActions.bookingNewSubmit ( { booking: booking }));
  }

  */

  goToCarDetailsPage(offerId: string): any{

    console.log("navigate to "+offerId);
    this.router.navigate(
      ['/buy-car/details'],
      { queryParams: { id: offerId} }
    );
  }

  goToSellerPage(sellerId: string): any{

    this.router.navigate(
      ['/buy-car/seller'],
      { queryParams: { id: sellerId } }
    );
  }

  goToCarEditPage(carId: string){

    this.router.navigate(
      ['/sell-car'],
      { queryParams: { id: carId} }
      );
  }

  openCarEditDialog(): void {

    //let car: Car = new Car();
    //car.country = 
    console.log(this.car);
 
    const dialogRef = this.dialog.open(CarEditDialogComponent, {
      //data: Object.assign(new Car(), this.car)
      data: structuredClone(this.car)
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      if(result != undefined ){
        //console.log(result)
        
        if(result.carId === ''){
          this.store.dispatch(DealerActions.createNewCarSubmit({ car: result }));
        }
        else{
          this.store.dispatch(DealerActions.updateCarSubmit({ carUpdates: result }));
        }
      }    
    });
  }

  deleteCar(carId: string){
     this.store.dispatch(DealerActions.deleteCarSubmit( {carId: carId}));
  }

  openProviderOfferDialogOld(carId: string, businessLine: CarBusinessLine): void {

    let car: Car = new Car();
    car.businessLine = businessLine
    car.carId = carId
    car.country = this.currentDealer.countryResident
    //car.country = 
    //console.log(offer);
 
    const dialogRef = this.dialog.open(ProviderOfferDialogComponent, {
      //data: Object.assign(new Car(), this.car)
      //data: structuredClone(this.car)
      data: structuredClone(car)
    });

    dialogRef.afterClosed().subscribe((result: any) => {

      if(result != undefined ){
        
        console.log(result)
        if(result.offerId === ''){
          console.log(result)
          this.store.dispatch(DealerActions.providerOfferNewSubmit({ providerOffer: result, objectSource: this.objectSource }));
        }
        else{
          this.store.dispatch(DealerActions.providerOfferUpdateSubmit({ providerOffer: result, objectSource: this.objectSource}));
        }
      }    
    });
  }

  openPriceDialog(carId: string, oldAmount: number, businessLine: CarBusinessLine): void {
    
    const dialogRef = this.dialog.open(NumberDialogComponent, {
      data: {amount: oldAmount, label: businessLine + " Price"}
    });

    dialogRef.afterClosed().subscribe((result: number) => {
      //console.log('New price = '+result+ " car Id = "+carId);
      //let newPrice: Price = new Price(businessLine, result, 0);
      
      if(result > 0 ){
        this.store.dispatch(DealerActions.createNewCarPriceSubmit( {carId: carId, businessLine: businessLine, price: new Price(result, Currency.XAF, 0) }));
      }
        
    });
  }

  prevImage(): void{
    console.log("current ="+this.currentImageIndex);
    if(this.currentImageIndex === 0 )
      this.currentImageIndex = this.carImagesFolder.length-1;
    else 
      this.currentImageIndex--;
    
    console.log("prev ="+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  nextImage(): void{
    console.log("current = "+this.currentImageIndex);

    if(this.currentImageIndex === this.carImagesFolder.length-1)
      this.currentImageIndex = 0;
    else 
      this.currentImageIndex++;
    console.log("next = "+this.currentImageIndex);
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  uploadImage(carId: string, event: any, ): void {

    let files: File[] = event.target.files;
    console.log('file name = '+files[0].name);

    if(files != undefined && files.length > 0){
      this.store.dispatch(FilesActions.uploadCarImageSubmit({ carId: carId, file: files[0] }));
    }
  }

  selectImage(index: number): void{
    this.currentImageIndex = index;
    this.currentImageIndexSubject.next(this.currentImageIndex);
  }

  updateCarStatus(carId: string, status: string){
    this.store.dispatch(DealerActions.updateCarStatusSubmit( {carId: carId, status: this.getCarStatusNext(status) }));
  }

  getCarStatusAction(status: string): string{
    return CarBasicData.carStatuses[status].action;
  }

  getCarStatusNext(status: string): string{
    return CarBasicData.carStatuses[status].next;
  }

  updateBusinessLineStatus(carId: string, status: boolean, businessLine: CarBusinessLine){
    console.log('status 1 = '+status);
    this.store.dispatch(DealerActions.toggleCarBusinessLineStatusSubmit( {carId: carId, status: status, businessLine: businessLine }));
  }

  
  updateProviderActiveStatus(carId: string, status: boolean){
    console.log('status 1 = '+status);

    this.store.dispatch(DealerActions.updateCarProviderActiveSubmit( {carId: carId, providerActive: status }));
  }

  updateProvider(carId: string, providerId: string){
    console.log('status 1 = ');
    this.store.dispatch(DealerActions.updateCarProviderSubmit( {carId: carId, providerId: providerId }));
  }

/*
  getPrice(businessLine: CarBusinessLine): Price{

    switch(businessLine.toString()){
      case CarBusinessLine.BUY.toString(): {

        return (this.car.buyPriceHistory != undefined && this.car.buyPriceHistory.length>0) ? this.car.buyPriceHistory[this.car.buyPriceHistory.length-1] : new Price(0,Currency.XAF,0);
      
      }

      case CarBusinessLine.RENT.toString(): {
        
        return (this.car.rentPriceHistory != undefined && this.car.rentPriceHistory.length>0) ? this.car.rentPriceHistory[this.car.rentPriceHistory.length-1] : new Price(0,Currency.XAF,0);
      
      }

      default: {
        return new Price(0,Currency.XAF,0)
      }
    }
  }

  getActiveState(businessLine: CarBusinessLine): boolean{

    switch(businessLine.toString()){
      case CarBusinessLine.BUY.toString(): {

        return (this.car.buyActiveHistory != undefined && this.car.buyActiveHistory.length>0) ? this.car.buyActiveHistory[this.car.buyActiveHistory.length-1] : false;
      
      }

      case CarBusinessLine.RENT.toString(): {
        
        return (this.car.rentActiveHistory != undefined && this.car.rentActiveHistory.length>0) ? this.car.rentActiveHistory[this.car.rentActiveHistory.length-1] : false;
      
      }

      default: {
        return false;
      }
    }
  }
*/

  getActiveState(businessLine: CarBusinessLine): boolean{

    switch(businessLine.toString()){
      case CarBusinessLine.BUY.toString(): {

        return this.car.buyActive;
      
      }

      case CarBusinessLine.RENT.toString(): {
        
        return this.car.rentActive;
      
      }

      default: {
        return false;
      }
    }
  }


  openProviderDialog(carId: string): void {
    
    const dialogRef = this.dialog.open(SelectDialogComponent, {
      data: {options: this.currentDealer.favoriteProviderIds, label: "Nouveau provider"}
    });

    dialogRef.afterClosed().subscribe((result: string) => {
      console.log('New provider = '+result+ " car Id = "+carId);
      //let newPrice: Price = new Price(businessLine, result, 0);
      
      if(result != undefined){
        this.store.dispatch(DealerActions.updateCarProviderSubmit( {carId: carId, providerId: result }));
      }
        
    });
  }

  openNewProviderOfferDialog(businessLine: CarBusinessLine): void {
  
    let objectData: ObjectData = new ObjectData(this.objectSource, "", 0, businessLine );
    objectData.carId = this.car.carId;

    //console.log('prop = '+JSON.stringify(carId));
    const dialogRef = this.dialog.open(ProviderOfferDialogComponent, {
      data: objectData
    });
  }

  canNewProposal(): boolean{
    return false;
  }

  canNewBooking(): boolean{
    let index = this.car.myBookings.findIndex(p => p.status !== BookingStatus.CANCELLED)
    return index === -1;
  }

  canNewConversation(): boolean{
    return false;
  }

  canNewAppointment(): boolean{
    return false;
  }

  canAddNewBuyOffer(): boolean{
    return ! (this.car.buyOffers!.length > 0);
  }

  canAddNewRentOffer(): boolean{
    return ! (this.car.rentOffers!.length > 0);
  }

}
